import React from 'react';
import ReactFlagsSelect from 'react-flags-select';

import { onClickWrapper } from '../../../utils/ui';

export default class FlagsSelect extends React.PureComponent {
  onSelectWrapper = (code) => {
    const { onChange, id } = this.props;
    onClickWrapper(`${id}-${code}`)();
    onChange && onChange(code);
  };

  render() {
    const { value, onChange, id, ...props } = this.props;

    return (
      <ReactFlagsSelect
        {...props}
        selected={value}
        onSelect={this.onSelectWrapper}
      />
    );
  }
}
